import { render, staticRenderFns } from "./SlideForm.vue?vue&type=template&id=0baaf660"
import script from "./SlideForm.vue?vue&type=script&lang=js"
export * from "./SlideForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports